import { FC } from 'react';
import { EstatePlanningTab } from './EstatePlanning.types';
import { Checklist } from './tabs/Checklist/Checklist';
import { Beneficiaries } from './tabs/Beneficiaries/Beneficiaries';
import { EssentialRoles } from './tabs/EssentialRoles/EssentialRoles';
import { EstatePlanningFlow } from './tabs/EstatePlanningFlow/EstatePlanningFlow';

export const ESTATE_PLANNING_TAB_MAP: Record<EstatePlanningTab, FC<any>> = {
  [EstatePlanningTab.Checklist]: Checklist,
  [EstatePlanningTab.Beneficiaries]: Beneficiaries,
  [EstatePlanningTab.EssentialRoles]: EssentialRoles,
  [EstatePlanningTab.EstateFlow]: EstatePlanningFlow,
};
